import React, { useState, useEffect } from "react";

import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";

import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function SROWiseLocationExamplerAndTotalDoc() {
  const [form, setForm] = useState({
    district: "",
    sro: "",
    regyear: "",
  });
  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);
  useEffect(() => {
    if (form.district) {
      fetchSros(form.district);
    } else {
      setSros([]);
    }
  }, [form.district]);

  const fetchSros = async (dcode) => {
    const res = await axios.get(
      `${API_BASE_URL}/Master/get_sro_master_data?dcode=${dcode}`
    );
    setSros(res.data.data);
  };

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout
      title="SRO Wise Location Exampler And Total Doc"
      onDownload={handleDownload}
    >
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="sro"
        label="Select SRO"
        value={form.sro}
        onChange={handleChange("sro")}
        options={sros.map((s) => ({ value: s.srocode, label: s.sroname }))}
      />
      <DateField
        id="regyear"
        label="Reg Year"
        value={form.regyear}
        onChange={handleChange("regyear")}
      />
    </ReportLayout>
  );
}
